import cloudNotAvailable from 'core/assets/images/icons/cloud_not_available.svg'

const DailyDataUnavailable = () => {
  return (
    <div data-testid="data-unavailable" className="mg-daily-data-unavailable vp-body-s">
      <img src={cloudNotAvailable} alt="Data not available" className="mg-daily-data-unavailable-icon" />
      --
    </div>
  )
}

export default DailyDataUnavailable
